import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CalibrantFooterComponent } from './calibrant-footer.component';
import {MatToolbarModule} from "@angular/material/toolbar";

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    MatToolbarModule
  ],
  declarations: [CalibrantFooterComponent],
  exports: [
    CalibrantFooterComponent
  ]
})
export class CalibrantFooterModule { }
